"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useSubmitBlogComment } from "@/hooks/blog/useSubmitBlogComment";
import { cn } from "@/lib/utils";

interface CommentFormProps {
  slug: string;
  parentId?: string;
  isLoggedIn: boolean;
  onRequireLogin: () => void;
  onDone?: () => void;
  compact?: boolean;
}

export const CommentForm: React.FC<CommentFormProps> = ({
  slug,
  parentId,
  isLoggedIn,
  onRequireLogin,
  onDone,
  compact,
}) => {
  const t = useTranslations("blog");
  const [value, setValue] = useState("");
  const submit = useSubmitBlogComment(slug);

  const onSubmit = () => {
    if (!isLoggedIn) return onRequireLogin();
    const content = value.trim();
    if (!content) return;
    submit.mutate(
      { content, parent_id: parentId },
      {
        onSuccess: () => {
          setValue("");
          onDone?.();
        },
      },
    );
  };

  return (
    <div className={cn("space-y-2", compact ? "mt-2" : "mt-1")}>
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={
          parentId ? t("form.replyPlaceholder") : t("form.placeholder")
        }
        className="w-full border-b border-stroke-light bg-transparent pb-2 text-sm text-text-primary outline-none placeholder:text-text-disabled"
      />
      <div className="flex items-center gap-2">
        {(parentId || value) && (
          <Button
            type="button"
            variant="bordered"
            colors="secondary"
            size="sm"
            onClick={() => {
              setValue("");
              onDone?.();
            }}
          >
            {t("form.cancel")}
          </Button>
        )}
        <Button
          type="button"
          variant="solid"
          colors="secondary"
          size="sm"
          disabled={submit.isPending}
          onClick={onSubmit}
        >
          {t("form.submit")}
        </Button>
      </div>
    </div>
  );
};
